import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import Template from "./booking-processor-selection.html";
import Controller from "./booking-processor-selection.controller";
import Bookings from "../../services/bookings.service";
import BookingProcessorSelectionModal from "./booking-processor-selection.modal";

let BookingProcessorSelectionModule = Angular.module('booking-processor-selection', [Bookings.name]);

BookingProcessorSelectionModule.component('bookingProcessorSelection', {
    template: Template,
    controller: Controller,
    bindings: {
        selectedProcessor: '<',
        onProcessorSelected: '&'
    },
});

new Loader(BookingProcessorSelectionModule)
    .load(BookingProcessorSelectionModal);

export default BookingProcessorSelectionModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-processor-selection/booking-processor-selection.js